export enum GraphType {
  MARKET_DATA_PLR_LATENCY = 'market-data-plr-latency-graph',
  MARKET_DATA_QHF_PLR_LATENCY = 'market-data-qhf-plr-latency-graph',
  MARKET_DATA_QRD_MLR = 'market-data-qrd-mlr-graph',
  MARKET_DATA_QFD_MLR = 'market-data-qfd-mlr-graph',
}
